const ELEMENT_IDS = {
  TITLE: 'mobTitle',
  DROPDOWN: 'collectionsDropdown'
} as const;

const CSS_CLASSES = {
  VISIBLE: 'visible',
  OPEN: 'open'
} as const;

const getRequiredElements = (): { title: HTMLElement; dropdown: HTMLElement } | null => {
  const title = document.getElementById(ELEMENT_IDS.TITLE);
  const dropdown = document.getElementById(ELEMENT_IDS.DROPDOWN);

  if (!title || !dropdown) {
    return null;
  }

  return { title, dropdown };
};

const toggleDropdown = (title: HTMLElement, dropdown: HTMLElement): void => {
  const isOpen = dropdown.classList.toggle(CSS_CLASSES.VISIBLE);
  title.classList.toggle(CSS_CLASSES.OPEN, isOpen);
  title.setAttribute('aria-expanded', String(isOpen));
};

const closeDropdown = (title: HTMLElement, dropdown: HTMLElement): void => {
  dropdown.classList.remove(CSS_CLASSES.VISIBLE);
  title.classList.remove(CSS_CLASSES.OPEN);
  title.setAttribute('aria-expanded', 'false');
};

const attachTitleClickHandler = (title: HTMLElement, dropdown: HTMLElement): void => {
  title.addEventListener('click', (): void => {
    toggleDropdown(title, dropdown);
  });
};

const attachAnchorClickHandlers = (title: HTMLElement, dropdown: HTMLElement): void => {
  dropdown.querySelectorAll<HTMLAnchorElement>('a').forEach((anchor: HTMLAnchorElement): void => {
    anchor.addEventListener('click', (): void => {
      closeDropdown(title, dropdown);
    });
  });
};

const attachEscapeHandler = (title: HTMLElement, dropdown: HTMLElement): void => {
  [title, dropdown].forEach((element: HTMLElement): void => {
    element.addEventListener('keydown', (event: KeyboardEvent): void => {
      if (event.key !== 'Escape' || !dropdown.classList.contains(CSS_CLASSES.VISIBLE)) {
        return;
      }

      closeDropdown(title, dropdown);
      title.focus();
    });
  });
};

const init = (): void => {
  const elements = getRequiredElements();
  
  if (!elements) {
    return;
  }

  const { title, dropdown } = elements;
  
  attachTitleClickHandler(title, dropdown);
  attachAnchorClickHandlers(title, dropdown);
  attachEscapeHandler(title, dropdown);
};

export { init };
